'use strict';

/**
 *
 * @name: apiSeriesService
 *
 */

function ApiSeriesService(
  $rootScope,
  $http
) {

  'ngInject';

  /**
   *
   * @PUBLIC
   *
   */

  function getSeries(page, limit, order, categoryId) {

    var target = $rootScope.apiUrlNew + '/series?' +
      (page ? '&page=' + page : '') +
      (limit ? '&limit=' + limit : '') +
      (order ? '&order=' + order : '') +
      (categoryId ? '&categoryId=' + categoryId : '');

    return $http.get(target);
  }

  function getSeriesById(id, includeComingSoon) {

    var target = $rootScope.apiUrlNew + '/series/' + id +
      (typeof includeComingSoon === 'boolean' ? '?includeComingSoon=' + includeComingSoon : '');

    return $http.get(target);
  }

  function getSeriesBySlug(slug, includeComingSoon) {

    var target = $rootScope.apiUrlNew + '/series/getbyslug/' + slug +
      (typeof includeComingSoon === 'boolean' ? '?includeComingSoon=' + includeComingSoon : '');

    return $http.get(target);
  }

  /**
   *
   * @PRIVATE
   *
   */

  return {
    getSeries: getSeries,
    getSeriesById: getSeriesById,
    getSeriesBySlug: getSeriesBySlug,
  };
}

export default ApiSeriesService;



// WEBPACK FOOTER //
// ./app/components/_api/series.service.js